import { useNavigate } from 'react-router-dom';

import { BsArrowRight, BsChevronRight, BsClockHistory, BsSearch } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import SectionCard from '#globalComponents/Card/SectionCard';
import Tag from '#globalComponents/Tag/Tag';
import { usePreferencesStore } from '#lib/stores/preferencesStore';

import { useB2bHeroLeadSearchQueries } from '../../../models/prospectQueries/queries';

const MAX_ITEMS = 5;

const formatCompanyCount = (count) => `${Number(count ?? 0).toLocaleString('de-DE')} Firmen`;

const RecentSearchesCard = () => {
	const navigate = useNavigate();
	const setLastSelectedSearchQueryId = usePreferencesStore((s) => s.setLastSelectedSearchQueryId);
	const { data, isLoading } = useB2bHeroLeadSearchQueries();

	const queries = (data?.data ?? []).slice(0, MAX_ITEMS);

	// /leads restores its selected search from this preference on mount
	const openQuery = (queryId) => {
		setLastSelectedSearchQueryId(queryId);
		navigate('/leads');
	};

	return (
		<SectionCard
			title="Letzte Suchen"
			icon={BsClockHistory}
			bodyClassName={queries.length > 0 ? 'p-2' : undefined}
			headerAction={
				queries.length > 0 && (
					<Button variant="outline" size="sm" onClick={() => navigate('/leads')}>
						Alle Leads
						<BsArrowRight className="w-3 h-3" />
					</Button>
				)
			}
		>
			{isLoading && <p className="text-sm text-bgBase-800">Suchen werden geladen …</p>}

			{!isLoading && queries.length === 0 && (
				<div className="flex flex-col items-start gap-3">
					<p className="text-sm text-bgBase-800">
						Sie haben noch keine Suche angelegt. Starten Sie mit Ihrer ersten Lead-Suche.
					</p>
					<Button size="sm" onClick={() => navigate('/leads')}>
						Erste Suche starten
					</Button>
				</div>
			)}

			<ul>
				{queries.map((query) => (
					<li key={query.id}>
						<button
							type="button"
							onClick={() => openQuery(query.id)}
							className="group w-full flex items-center gap-3 rounded-control p-2 text-left hover:bg-bgBase-300 transition-colors"
						>
							<BsSearch className="w-3.5 h-3.5 text-bgBase-700 flex-shrink-0" />
							<span className="flex-1 min-w-0 text-sm font-medium text-text truncate">
								{query.queryName}
							</span>
							{query.isShared && <Tag label="Geteilt" tone="neutral" size="xs" />}
							<span className="text-xs text-bgBase-800 whitespace-nowrap">
								{formatCompanyCount(query.companyCount)}
							</span>
							<BsChevronRight className="w-3 h-3 text-bgBase-700 group-hover:text-primary-500 transition-colors" />
						</button>
					</li>
				))}
			</ul>
		</SectionCard>
	);
};

export default RecentSearchesCard;
